
import { Vue, Component, Prop } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'GamePoints',
  components: {
    Icon
  }
})
export default class GamePoints extends Vue {
  @Prop({ type: Number, default: 0 }) points!: number

  get text() {
    return `${this.points} ${this.$pluralize('point', this.points)}`
  }
}
